import ApiRequest from '../api/request';

type Params = { route?: 'component'; action: any; params?: any };

export default class Component {
  static async Interact(params: Params, apiToken: string) {
    try {
      const response = await ApiRequest.sendRequest({
        method: 'post',
        params: {},
        path: `component/${params.action}`,
        token: apiToken,
      });
      return response.data;
    } catch (err: any) {
      return { error: err.message };
    }
  }
}
